module.exports = __webpack_public_path__ + "img/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.aa16495f.webp";